export default {
	title: 'adc_actions',
	components: [{ title: 'adc_actions', component: 'adc_actions' }],
};
